import { Component, inject, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { BasicButtonColors, BasicButtonModes, BasicButtonSizes } from '@app/shared/enums/buttons';
import { SnackBarsTypes } from '@app/shared/enums/snackbars';
import { SnackbarData } from '@app/shared/interfaces/snackbar.interface';

@Component({
  selector: 'cm-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss', '../../../styles/base/_typography.scss'],
})
export class SnackBarComponent {
  snackbarIcon: string;
  SnackBarsTypes = SnackBarsTypes;
  BasicButtonColors = BasicButtonColors;
  BasicButtonSizes = BasicButtonSizes;
  BasicButtonModes = BasicButtonModes;
  public data = inject(MAT_SNACK_BAR_DATA) as SnackbarData;

  constructor(
    public sbRef: MatSnackBarRef<SnackBarComponent>,
  ) {
    switch (this.data.type) {
      case SnackBarsTypes.SUCCESS:
        this.snackbarIcon = 'check_circle_outlined';
        break;
      case SnackBarsTypes.ERROR:
        this.snackbarIcon = 'error_outline';
        break;
      case SnackBarsTypes.WARNING:
        this.snackbarIcon = 'warning_amber_outline';
        break;
      case SnackBarsTypes.INFO:
        this.snackbarIcon = 'info_outline';
        break;
      default:
        break;
    }
  }

  close(): void {
    this.data?.customAction ? this.sbRef.dismissWithAction() : this.sbRef.dismiss();
  }

  action(): void {
    this.sbRef.dismissWithAction();
    if (this.data?.customAction) {
      this.data?.customAction();
    }
  }
}
